import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface lockViewState {
  [eventId: string]: {
    [lockViewNumber: number]: {
      lockedLayout: { id: string }[];
    };
  };
}

const initialState: lockViewState = {};

const lockViewSlice = createSlice({
  name: 'lockView',
  initialState,
  reducers: {
    addLockView: (
      state,
      action: PayloadAction<{
        eventId: string;
        setup: { lockViewNumber: number; lockedLayout: { id: string }[] };
      }>
    ) => {
      const { eventId, setup } = action.payload;
      if (!state[eventId]) {
        state[eventId] = {};
      }
      state[eventId][setup.lockViewNumber] = {
        lockedLayout: setup.lockedLayout,
      };
    },
    deleteLockView: (
      state,
      action: PayloadAction<{
        eventId: string;
        lockViewNumber: number;
      }>
    ) => {
      const { eventId, lockViewNumber } = action.payload;
      if (state[eventId]) {
        delete state[eventId][lockViewNumber];
      }
    },
  },
});

export const { addLockView, deleteLockView } = lockViewSlice.actions;
export default lockViewSlice.reducer;
